import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import ActionCenterNewMessage from './ActionCenterNewMessage';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	defaultData?: object;
}

const ActionCenterNewMessageModal: React.FC<Props> = ({
	isOpen,
	onClose,
	defaultData,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.LG}>
			<Modal.Header title={'base.newMessage'} firstUpper />
			<Modal.Content>
				<ActionCenterNewMessage defaultData={defaultData} onSuccess={onClose} />
			</Modal.Content>
		</Modal>
	);
};

export default ActionCenterNewMessageModal;
